import ConciergeDirectAuth from '@/pages/hotel/concierge/ConciergeDirectAuth'
import PreCheckinRoomList from '@/pages/hotel/concierge/PreCheckinRoomList'
import PreCheckinForm from '@/pages/hotel/concierge/PreCheckinForm'
import MaintenanceService from '@/pages/hotel/concierge/maintenanceservice/MaintenanceService'
import ConciergeInquiry from '@/pages/hotel/concierge/ConciergeInquiry'
import ConciergePaymentResult from '@/pages/hotel/concierge/ConciergePaymentResult'
import ConciergeOrder from '@/pages/hotel/concierge/Order'
import ConciergeSpa from '@/pages/hotel/concierge/spaV2'
import ConciergeSpaCart from '@/pages/hotel/concierge/spaV2/Cart'
import ConciergeSpaSelect from '@/pages/hotel/concierge/spa/SpaSelect'
import ConciergeSpaSuccess from '@/pages/hotel/concierge/spa/SpaSuccess'
import ConciergeExtraAmenities from '@/pages/hotel/concierge/extraamenities/ExtraAmenities'
import ConciergeExtraAmenitiesCart from '@/pages/hotel/concierge/extraamenities/ExtraAmenitiesCart'
import ConciergeExtraAmenitiesSuccess from '@/pages/hotel/concierge/extraamenities/ExtraAmenitiesSuccess'
import ConciergeLaundry from '@/pages/hotel/concierge/laundry/Laundry'
import ConciergeLaundryCart from '@/pages/hotel/concierge/laundry/LaundryCart'
import ConciergeLaundrySuccess from '@/pages/hotel/concierge/laundry/LaundrySuccess'
import ConciergeMember from '@/pages/hotel/concierge/member/Member'
import ConciergeAccount from '@/pages/hotel/concierge/account/Account'
import ConciergePersonalData from '@/pages/hotel/concierge/account/PersonalData'
import ConciergeLanguage from '@/pages/hotel/concierge/account/Language'
import ConciergeHelp from '@/pages/hotel/concierge/account/Help'
import ConciergeRoomDining from '@/pages/hotel/concierge/roomdining/RoomDining'
import ConciergeRoomDiningSearch from '@/pages/hotel/concierge/roomdining/RoomDiningSearch'
import ConciergeRoomDiningCart from '@/pages/hotel/concierge/roomdining/RoomDiningCart'
import ConciergeRoomDiningSuccess from '@/pages/hotel/concierge/roomdining/RoomDiningSuccess'
import ConciergeThingsToDo from '@/pages/hotel/concierge/thingstodo/index'
import ConciergeThingsToDoDetail from '@/pages/hotel/concierge/thingstodo/MerchantDetail'
import ConciergeThingsToDoProductList from '@/pages/hotel/concierge/thingstodo/ProductList'
import ConciergeThingsToDoCart from '@/pages/hotel/concierge/thingstodo/MerchantCart'
import BeModuleServiceTrxResult from '@/pages/hotel/concierge/ConciergeTrxResult'
import GuestPreference from '@/pages/hotel/concierge/PreferenceForm'
import PosHome from '@/pages/hotel/concierge/pos'
import PosSearch from '@/pages/hotel/concierge/pos/Search'
import PosProductDetail from '@/pages/hotel/concierge/pos/ProductDetail'
import PosCart from '@/pages/hotel/concierge/pos/Cart'
import PosPaymentResult from '@/pages/hotel/concierge/pos/PaymentResult'
import PosBookingTable from '@/pages/hotel/concierge/pos/BookingTable'
import PosBookingTableResult from '@/pages/hotel/concierge/pos/BookingTableResult'
import PosDetail from '@/pages/hotel/concierge/pos/DetailPos'
import HotelActivity from '@/pages/hotel/concierge/activity'
import HotelActivityCart from '@/pages/hotel/concierge/activity/Cart'

const emptyView = {template: '<router-view></router-view>'} 

export default [
  {
    path: 'concierge',
    name: 'ConciergeBase',
    component: emptyView,
    children:[
      {
        path: '',
        name: 'ConciergeMainPage',
        beforeEnter: (to, from, next) => {
          next(`/${to.params.merchant_code}`)
        },
        component: emptyView,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      },
      {
        path: 'auth',
        name: 'ConciergeDirectAuth',
        component: ConciergeDirectAuth,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      },
      {
        path: 'precheckin/:booking_number',
        name: 'PreCheckinRoomList',
        component: PreCheckinRoomList,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      },
      {
        path: 'precheckin-form/:pms_detail_id',
        name: 'PreCheckinForm',
        component: PreCheckinForm,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      },
      {
        path: 'maintenance-request',
        name: 'MaintenanceService',
        component: MaintenanceService,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      },
      {
        path: 'payment-result/:reservation_id/:tx_payment_id',
        name: 'ConciergePaymentResult',
        component: ConciergePaymentResult,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      },
      {
        path: 'order',
        name: 'ConciergeOrder',
        component: ConciergeOrder,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      },
      {
        path: 'room-dining',
        name: 'ConciergeRoomDiningBase',
        component: emptyView,
        children: [
          {
            path: '',
            name: 'ConciergeRoomDining',
            component: ConciergeRoomDining,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'search',
            name: 'ConciergeRoomDiningSearch',
            component: ConciergeRoomDiningSearch,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'cart',
            name: 'ConciergeRoomDiningCart',
            component: ConciergeRoomDiningCart,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          }
        ]
      },
      {
        path: 'spa',
        name: 'ConciergeSpaBase',
        component: emptyView,
        children: [
          {
            path: '',
            name: 'ConciergeSpa',
            component: HotelActivity,
            meta:{
              module_type: 'merchant-hotel-concierge',
              sub_module: 'concierge-spa',
              no_wrapper: true
            }
          },
          {
            path: 'cart',
            name: 'ConciergeSpaCart',
            component: HotelActivityCart,
            meta:{
              module_type: 'merchant-hotel-concierge',
              sub_module: 'concierge-spa',
              no_wrapper: true
            }
          }
        ]
      },
      {
        path: 'extra-amenities',
        name: 'ConciergeExtraAmenitiesBase',
        component: emptyView,
        children: [
          {
            path: '',
            name: 'ConciergeExtraAmenities',
            component: ConciergeExtraAmenities,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'cart',
            name: 'ConciergeExtraAmenitiesCart',
            component: ConciergeExtraAmenitiesCart,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'success',
            name: 'ConciergeExtraAmenitiesSuccess',
            component: ConciergeExtraAmenitiesSuccess,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          }
        ]
      },
      {
        path: 'laundry',
        name: 'ConciergeLaundryBase',
        component: emptyView,
        children: [
          {
            path: '',
            name: 'ConciergeLaundry',
            component: ConciergeLaundry,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'cart',
            name: 'ConciergeLaundryCart',
            component: ConciergeLaundryCart,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'success',
            name: 'ConciergeLaundrySuccess',
            component: ConciergeLaundrySuccess,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
        ]
      },
      {
        path: 'member',
        name: 'ConciergeMember',
        component: ConciergeMember,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      },
      {
        path: 'account',
        name: 'ConciergeAccountBase',
        component: emptyView,
        children:[
          {
            path: '',
            name: 'ConciergeAccount',
            component: ConciergeAccount,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'personal-data',
            name: 'ConciergePersonalData',
            component: ConciergePersonalData,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'language',
            name: 'ConciergeLanguage',
            component: ConciergeLanguage,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: 'help',
            name: 'ConciergeHelp',
            component: ConciergeHelp,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
        ]
      },
      {
        path: 'experience',
        name: 'ConciergeThingsToDoBase',
        component: emptyView,
        children:[
          {
            path: '',
            name: 'ConciergeThingsToDo',
            component: ConciergeThingsToDo,
            meta:{
              module_type: 'merchant-hotel-concierge'
            }
          },
          {
            path: ':id',
            name: 'ConciergeThingsToDoDetailBase',
            component: emptyView,
            children:[
              {
                path: '',
                name: 'ConciergeThingsToDoDetail',
                component: ConciergeThingsToDoDetail,
                meta:{
                  module_type: 'merchant-hotel-concierge'
                }
              },
              {
                path: 'list',
                name: 'ConciergeThingsToDoProductList',
                component: ConciergeThingsToDoProductList,
                meta:{
                  module_type: 'merchant-hotel-concierge'
                }
              },
              {
                path: 'cart',
                name: 'ConciergeThingsToDoCart',
                component: ConciergeThingsToDoCart,
                meta:{
                  module_type: 'merchant-hotel-concierge'
                }
              }
            ]
          },
        ]
      },
      {
        path: 'trx-result/:trx_id',
        name: 'BeModuleServiceTrxResult',
        component: BeModuleServiceTrxResult,
        meta:{
          module_type: 'merchant-hotel-concierge',
          no_wrapper: true
        }
      },
      {
        path: 'preference/:reservation_id',
        name: 'GuestPreference',
        component:GuestPreference,
        meta:{
          module_type: 'merchant-hotel-concierge'
        }
      }
    ]
  },
  {
    path: 'concierge-inquiry',
    name: 'ConciergeInquiry',
    component: ConciergeInquiry,
    meta:{
      module_type: 'merchant-hotel-concierge'
    }
  },
  {
    path: 'order/:pos_code',
    name: 'PosBase',
    component: emptyView,
    children:[
      {
        path: '',
        name: 'PosHome',
        component: PosHome,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-outlet',
          no_wrapper: true
        }
      },
      {
        path: 'detail',
        name: 'PosDetail',
        component: PosDetail,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-outlet',
          no_wrapper: true
        }
      },
      {
        path: 'search',
        name: 'PosSearch',
        component: PosSearch,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-outlet',
          no_wrapper: true
        }
      },
      {
        path: 'product/:product_id',
        name: 'PosProductDetail',
        component: PosProductDetail,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-outlet',
          no_wrapper: true
        }
      },
      {
        path: 'cart',
        name: 'PosCart',
        component: PosCart,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-outlet',
          no_wrapper: true
        }
      },
      {
        path: 'payment-result/:tx_order_id',
        name: 'PosPaymentResult',
        component: PosPaymentResult,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-outlet',
          no_wrapper: true
        }
      },
      {
        path: 'book-table',
        name: 'PosBookingTable',
        component: PosBookingTable,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-outlet',
          no_wrapper: true
        }
      },
      {
        path: 'book-table/result/:tx_order_id',
        name: 'PosBookingTableResult',
        component: PosBookingTableResult,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-outlet',
          no_wrapper: true
        }
      }
    ]
  },
  {
    path: 'book/:pos_code',
    name: 'HotelActivityBase',
    component: emptyView,
    children:[
      {
        path: '',
        name: 'HotelActivity',
        component: HotelActivity,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-activity',
          no_wrapper: true
        }
      },
      {
        path: 'cart',
        name: 'HotelActivityCart',
        component: HotelActivityCart,
        meta:{
          module_type: 'merchant-hotel-pos',
          sub_module: 'hotel-activity',
          no_wrapper: true
        }
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/merchant/hotel/Concierge.js